import { useEffect, useState } from "react";
import { GlassContainer } from "../components/Containers";
import { Statistic, Typography } from "antd";
import Buttons from "../components/Buttons";
import { ShoppingCartOutlined } from "@ant-design/icons";
import CountUp from "react-countup";

export default function Shares(args) {
  const [sharesSoldCount, setSharesSoldCount] = useState(0);
  const [sharesAvailableCount, setSharesAvailableCount] = useState(0);
  const [shareCount, setShareCount] = useState(0);

  const formatter = (value) => <CountUp end={value} separator="," />;

  async function getShareCount() {
    await fetch("https://api.zenofy.tr/shareCount")
      .then((res) => res.json())
      .then((json) => {
        setShareCount(json.count);
      });
  }

  async function getSharesSoldCount() {
    await fetch("https://api.zenofy.tr/sharesSoldCount")
      .then((res) => res.json())
      .then((json) => {
        setSharesSoldCount(json.count);
        setSharesAvailableCount(shareCount - json.count);
      });
  }
  useEffect(() => {
    args.setCurrent("shares");
    document.title = "Hisseler | Zenofy";
    getShareCount();
    getSharesSoldCount();
  });

  return (
    <div
      style={{
        marginTop: "3rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "2rem",
        overflow: "hidden",
      }}
    >
      <GlassContainer
        device={args.device}
        width="60vw"
        small_width="95vw"
        height="20rem"
        bigger_height="15rem"
        inside={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: "1rem",
              flexWrap: "wrap",
              margin: "1rem",
            }}
          >
            <GlassContainer
              device={args.device}
              width="max(10vw,10rem)"
              bigger_height="10rem"
              opacity={0.5}
              lightness={50}
              saturation={80}
              hue={200}
              flexGrow
              inside={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography.Title
                    style={{
                      fontSize: "5rem",
                      color: "white",
                      margin: "0",
                    }}
                  >
                    <Statistic
                      styles={{
                        content: {
                          fontSize: "5rem",
                          color: "white",
                          margin: "0",
                        },
                      }}
                      value={sharesAvailableCount}
                      formatter={formatter}
                    />
                  </Typography.Title>
                  <Typography.Title
                    style={{
                      fontSize: "2rem",
                      color: "var(--light)",
                      margin: "0",
                    }}
                  >
                    Hisse <br />
                    Mevcut
                  </Typography.Title>
                </div>
              }
            />
            <GlassContainer
              device={args.device}
              width="max(10vw,10rem)"
              bigger_height="10rem"
              opacity={0.5}
              lightness={50}
              saturation={80}
              hue={200}
              flexGrow
              inside={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography.Title
                    style={{
                      fontSize: "5rem",
                      color: "white",
                      margin: "0",
                    }}
                  >
                    <Statistic
                      styles={{
                        content: {
                          fontSize: "5rem",
                          color: "white",
                          margin: "0",
                        },
                      }}
                      value={sharesSoldCount}
                      formatter={formatter}
                    />
                  </Typography.Title>
                  <Typography.Title
                    style={{
                      fontSize: "2rem",
                      color: "var(--light)",
                      margin: "0",
                    }}
                  >
                    Hisse <br />
                    Satıldı
                  </Typography.Title>
                </div>
              }
            />
            <GlassContainer
              device={args.device}
              width="max(10vw,10rem)"
              bigger_height="10rem"
              opacity={0.5}
              lightness={50}
              saturation={80}
              hue={200}
              flexGrow
              inside={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography.Title
                    style={{
                      fontSize: "5rem",
                      color: "white",
                      margin: "0",
                    }}
                  >
                    <Statistic
                      styles={{
                        content: {
                          fontSize: "5rem",
                          color: "white",
                          margin: "0",
                        },
                      }}
                      value={shareCount}
                      formatter={formatter}
                    />
                  </Typography.Title>
                  <Typography.Title
                    style={{
                      fontSize: "2rem",
                      color: "var(--light)",
                      margin: "0",
                    }}
                  >
                    Toplam <br />
                    Hisse
                  </Typography.Title>
                </div>
              }
            />
          </div>
        }
      />
      <GlassContainer
        device={args.device}
        width="70vw"
        small_width="95vw"
        height="15rem"
        bigger_height="25rem"
        inside={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "2rem",
              margin: "1rem",
            }}
          >
            <GlassContainer
              width="20vw"
              small_width="80vw"
              device={args.device}
              height="10rem"
              bigger_height="16rem"
              hue={200}
              saturation={80}
              lightness={50}
              opacity={0.5}
              hoverAnimation
              inside={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    gap: "1rem",
                    margin: "1rem",
                  }}
                >
                  <Typography.Title
                    style={{
                      fontSize: "2rem",
                      color: "var(--light)",
                      margin: "0",
                    }}
                  >
                    Hisse Fiyatı:
                  </Typography.Title>
                  <Typography.Title
                    style={{
                      fontSize: "5rem",
                      color: "var(--light)",
                      margin: "0",
                    }}
                  >
                    220TL
                  </Typography.Title>
                </div>
              }
            />
            <GlassContainer
              device={args.device}
              width="40vw"
              small_width="80vw"
              height="10rem"
              bigger_height="16rem"
              hue={210}
              saturation={60}
              lightness={60}
              opacity={0.5}
              noBg
              inside={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    gap: "2.4rem",
                    margin: "1rem",
                  }}
                >
                  <Typography.Title
                    style={{
                      fontSize: "2rem",
                      color: "var(--light)",
                      margin: "0",
                    }}
                  >
                    Sen de şimdi şirketimizin bir parçası ol!
                  </Typography.Title>
                  <Buttons
                    buttonsPrimary={["Şimdi Al"]}
                    iconsPrimary={[<ShoppingCartOutlined />]}
                  />
                </div>
              }
            />
          </div>
        }
      />
    </div>
  );
}
